<template>
  <div>
    <button
      :class="`${button_class}`"
      type="button"
      @click="open"
    >
      <i class="fa fa-file" style="margin-right: 10px;"></i>
      <span>Certificate Sample</span>
    </button>

    <div :class="`modal ${active ? 'is-active' : null} certificate-modal`">
      <div class="modal-background"></div>
      <div class="certificate-modal-content">
        <div class="certificate-modal-image">
          <img :src="certificate" class="certificate-image">
          <div v-if="alert && show_attention_message" ref="alert" class="certificate-modal-alert">
            <i class="fa fa-times" @click="closeAlert"></i>
            <b>ATTENTION</b>
            <p>The Certificate issued after completing this course is NOT an EASA Form 149a (Certificate of Recognition)</p>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="close"></button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CertificateSample',

  props: {
    button_class: {
      required: false,
      type: String,
      default: 'button is-info is-outlined is-medium'
    },

    certificate: {
      required: true,
      type: String
    },

    show_attention_message: {
      required: false,
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      active: false,
      alert: false
    };
  },

  methods: {
    open() {
      this.active = true;
      setTimeout(this.openAlert, 750);
    },

    close() {
      this.active = false;
      this.alert = false;
    },

    openAlert() {
      this.alert = true;
    },

    closeAlert() {
      this.alert = false;
    }
  }
};
</script>
